// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingRule.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable } from 'mobx';
import { uniqueId, get, isNumber } from "lodash/fp";
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';
const { CONDITION_TYPE } = constants;

export default class ConditionalFormattingRule{
  id = null;
  @observable condition = null;
  @observable fields = [];
  @observable format = null;

  constructor(rule){
    this.id = this.getUniqueId();
    if(rule){
      this.parseData(rule);
    }
  }

  getUniqueId(){
    return uniqueId('conditionalFormattingRule_');
  }

  isEmpty(){
    const {condition, fields, format} = this;

    let isConditionValueEmpty = true;
    let isFieldsListEmpty = true;
    let isFormatValueEmpty = true;

    const conditionType = get('type', condition);
    switch(conditionType){
      case CONDITION_TYPE.ALL_VALUES.value:
      case CONDITION_TYPE.BLANK.value:
      case CONDITION_TYPE.NULL.value:
        isConditionValueEmpty = false;
        break;
      case CONDITION_TYPE.VALUE.value:
        isConditionValueEmpty = get('value', condition) ? false : true;
        break;
      case CONDITION_TYPE.RANGE_PERCENT.value:
      case CONDITION_TYPE.RANGE_VALUE.value:
        const from = get('value.from', condition);
        const to = get('value.to', condition);
        isConditionValueEmpty = isNumber(from) && isNumber(to) ? false : true;
    }

    isFieldsListEmpty = fields.length !== 0 ? false : true;

    isFormatValueEmpty = get('value', format) ? false : true;

    return isConditionValueEmpty && isFieldsListEmpty && isFormatValueEmpty;
  }

  serializeData(){
    const {condition, fields, format} = this;
    return {
      condition: condition,
      fields: fields,
      format: format
    }
  }

  parseData(rule){
    const {condition, fields, format} = rule;
    this.condition = condition;
    this.fields = fields;
    this.format = format;
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingRule.js